/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Description_Length_HelpInputs */



/**
* | output |
* | --- |
* | "Choose how long each shot description should be. This does not change the length of the audio description script." |
*
* @param {Ad_Description_Length_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_description_length_help = /** @type {((inputs?: Ad_Description_Length_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Description_Length_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisissez la longueur de chaque description de plan. Cela ne modifie pas la longueur du script d'audiodescription.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie, wie lang jede Einstellungsbeschreibung sein soll. Die Länge des Audiodeskriptions-Skripts ändert sich dadurch nicht.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scegli la lunghezza di ogni descrizione dell'inquadratura. Non modifica la lunghezza del copione di audiodescrizione.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите длину описания каждого плана. Это не влияет на длину сценария тифлокомментария.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Elige la longitud de cada descripción de plano. No cambia la longitud del guion de audiodescripción.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择每条镜头描述的长度。这不会改变口述影像脚本的长度。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("各ショット説明の長さを選択してください。音声解説スクリプトの長さは変わりません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चुनें कि प्रत्येक शॉट विवरण कितना लंबा हो। इससे ऑडियो विवरण स्क्रिप्ट की लंबाई नहीं बदलती।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Escolha o comprimento de cada descrição de plano. Não altera o comprimento do guião de audiodescrição.")
	return /** @type {LocalizedString} */ ("Choose how long each shot description should be. This does not change the length of the audio description script.")
});